










import {Component, Vue} from 'vue-property-decorator';
import SideBarActions from "@/view/sidebar/store-module/utility";
import {mapGetters} from "vuex";

@Component({
    components: {},
    computed: {
        ...mapGetters(['getFirstName', 'getLastName', 'getEmail']),
    }
})
export default class ProfileHeader extends Vue {

    private toggleNav(): void {
        this.$store.dispatch(SideBarActions.TOGGLE_SIDEBAR);
    }
}
